<template>
  <div class="root">
    <div class="inner">
      <report-panel
        :editorID="config.id"
        :filterID="dataSalesOrder.supplierCompanyID"
        :isVisibleReports.sync="isVisibleReports"
        :activeTabReports.sync="activeTabReports"
      />
      <div class="content">
        <vue-custom-scrollbar>
          <div class="content__scroll">
            <section-po-general
              ref="po-general"
              :data="dataSalesOrder"
              @change="updateFormDataSalesOrder"
            />
            <section-rfq-general
              ref="rfq-general"
              :data="data"
              @change="handleFormData"
            />
            <section-rfq-2
              ref="rfq-2"
              :data="data"
              :supplierCompanyID="dataSalesOrder.supplierCompanyID"
              :baxpo="dataSalesOrder.baxpo"
              @onSetLoading="isLoading = $event"
            />
            <section-supplier
              ref="supplier"
              :data="dataSalesOrder"
              @change="updateFormDataSalesOrder"
            />
            <section-shipping
              ref="shipping"
              :data="dataSalesOrder"
              @change="updateFormDataSalesOrder"
            />
            <section-close-po
              :isClosePoValidate="isClosePoValidate"
              :dataSalesOrder.sync="dataSalesOrder"
              @onClosePO="handleClosePO"
            />
          </div>

        </vue-custom-scrollbar>
        <div class="vb-md content__border" />
        <vue-custom-scrollbar>
          <div class="content__scroll">
            <buttons-sections
              :id="data.id"
              :salesOrderID="salesOrderID"
              @onPrintWorkOrder="handlePrintWorkOrder"
              @onPrintPO="handlePrintPO"
              @onPrintProformaSupplier="handlePrintProformaSupplier"
              @onSentPO="handleSentPO"
              @onSentWO="handleSentWO"
              @onAddToSupportPoFollowUp="handleAddToSupportPoFollowUp"
              @command="controllerButtonCommand"
            />
            <customer-market-data :supplierCompanyID="formDataSalesOrder.supplierCompanyID"  />
          </div>

        </vue-custom-scrollbar>
      </div>

      <div>
        <form-controls
          class="form-footer mx-4"
          :isSave="hasCreateNew"
          @command="setCommand">
          <button type="button" class="btn btn-size-s btn-mobile-full mx-1" @click="handlerConnectPO">
            {{L10n('open-po')}}
          </button>
          <button type="button" class="btn btn-size-s btn-mobile-full mx-1" @click="handlerConnectWO">
            {{L10n('open-wo')}}
          </button>
        </form-controls>
      </div>
    </div>
    <send-email-wrap
      ref="sendEmailWrap"
      :rfqUID="this.currentID"
      :rfqid="data.rfqid"
      :salesOrderID="dataSalesOrder.id"
      :supplierCompanyID="dataSalesOrder.supplierCompanyID"
    />
    <dialog-connect-wo ref="dialog-connect-wo" />
    <dialog-connect-po ref="dialog-connect-po" />
  </div>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { ServiceRFQs } from '@/services/RFQs'
import { ServiceSalesOrders } from '@/services/SalesOrders'
import { ServicePdf } from '@/services/pdf-generators'
import { toDate } from '@/utils/filters'
import { downloadBase64 } from '@/utils/files'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapper],
  components: {
    // 'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'buttons-sections': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './ButtonsSection.vue'),
    'customer-market-data': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './CustomerMarketData.vue'),
    // Sections
    'section-po-general': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SectionPOGeneral/Index.vue'),
    'section-rfq-general': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SectionRFQGeneral/Index.vue'),
    'section-rfq-2': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SectionRFQ2/Index.vue'),
    'section-supplier': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SectionSupplier/Index.vue'),
    'section-shipping': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SectionShipping/Index.vue'),
    'section-close-po': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SectionClosePo/Index.vue'),
    // Reports
    'report-panel': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierQuotesReports/Index.vue'),
    'send-email-wrap': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './SendEmailWrap'),

    'dialog-connect-po': () => import(/* webpackChunkName: 'DialogConnectPo' */ '@/components/Shared/ActivityDialogConnectToOpenPO/Index'),
    'dialog-connect-wo': () => import(/* webpackChunkName: 'DialogConnectWo' */ '@/components/Shared/ActivityDialogConnectToOpenWO/Index')
  },
  props: {
    poStillOpen: { type: Boolean, required: true },
    config: { type: Object },
    salesOrderID: { required: true }
  },
  watch: {
    salesOrderID: {
      immediate: true,
      handler (v) {
        if (v) {
          this.requestLoadSalesOrders(v)
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      activeTabReports: 'special-instructions',
      isVisibleReports: false,
      isClosePoValidate: false,

      dataSalesOrder: {},
      formDataSalesOrder: {}
    }
  },
  methods: {
    async handlePrintWorkOrder (logoKey) {
      this.isLoading = true
      const { id } = this.data
      const { baxpo } = this.dataSalesOrder
      try {
        const { data: pdfBase64 } = await ServicePdf.generateWo({ id, salesOrderID: this.salesOrderID, logoKey, translate: this.L10n })
        const fileName = encodeURIComponent(`WO_${baxpo}_${toDate(new Date(), 'YYYY-MM-DD')}`)
        await downloadBase64(pdfBase64, fileName)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async handlePrintPO (logoKey) {
      this.isLoading = true
      const { id } = this.data
      const { baxpo } = this.dataSalesOrder
      try {
        const { data: pdfBase64 } = await ServicePdf.generatePo({ id, salesOrderID: this.salesOrderID, logoKey, translate: this.L10n })
        const fileName = encodeURIComponent(`PO_${baxpo}_${toDate(new Date(), 'YYYY-MM-DD')}`)
        await downloadBase64(pdfBase64, fileName)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async handlePrintProformaSupplier (logoKey) {
      this.isLoading = true
      const { id } = this.data
      const { baxpo } = this.dataSalesOrder

      try {
        const { data: pdfBase64 } = await ServicePdf
          .generateProformaShipSupplier({ id, salesOrderID: this.salesOrderID, logoKey, translate: this.L10n })
        const fileName = encodeURIComponent(`Shipping-Proforma_${baxpo}_${toDate(new Date(), 'YYYY-MM-DD')}`)
        await downloadBase64(pdfBase64, fileName)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
      this.$bus.$emit('print-proforma-supplier')
    },
    handleSentPO (logoType) {
      this.$refs['sendEmailWrap'].show({ isSendPO: true, logoType })
    },
    handleSentWO (logoType) {
      this.$refs['sendEmailWrap'].show({ isSendPO: false, logoType })
    },
    handleAddToSupportPoFollowUp () {
      const { rfqid, baxpo, employeeID } = this.dataSalesOrder
      const data = {
        rfqid, baxpo, employeeID
      }
      this.$bus.$emit('add-to-support-po-followup', data)
    },
    controllerButtonCommand (command) {
      if (command === 'update-stock-location-and-status') {
        this.actionUpdateStockLocationAndStatus()
      }
      if (command === 'add-new-pn-to-stock') {
        this.actionAddNewPnToStock()
      }
    },
    actionUpdateStockLocationAndStatus () {
      const id = this.dataSalesOrder.id
      this.isLoading = true

      return ServiceSalesOrders
        .updateStock({ id })
        .then(this.requestSuccessHandler)
        .catch(this.requestErrorHandler)
        .finally(() => {
          this.isLoading = false
        })
    },
    actionAddNewPnToStock () {
      const id = this.dataSalesOrder.id
      this.isLoading = true

      return ServiceSalesOrders
        .addToStock({ id })
        .then(this.requestSuccessHandler)
        .catch(this.requestErrorHandler)
        .finally(() => { this.isLoading = false })
    },
    handleClosePO () {
      this.isClosePoValidate = true

      this.$nextTick(() => {
        this.$bus
          .$emitPromise('on-close-po')
          .then(() => {
            this.requestClosePO()
          })
          .catch((e) => {
            this.validateErrorHandler(e)
          })
      })
    },
    requestClosePO () {
      const { id } = this.dataSalesOrder
      const { id: rfqID } = this.data
      this.isLoading = true

      ServiceSalesOrders
        .closePO({ id, rfqID })
        .then(() => {
          this.requestSuccessHandler()
          this.refresh()
        })
        .catch(this.requestErrorHandler)
        .finally(() => {
          this.isLoading = false
        })
    },
    requestLoadSalesOrders (v) {
      this.isLoading = true
      this._requestLoadSalesOrders(v)
        .then(() => {
          this.isLoading = false
        })
        .catch((e) => {
          this.requestErrorHandler(e, `Supplier Order not found`)
          this.setQuery()
        })
    },
    updateFormDataSalesOrder (data) {
      this.formDataSalesOrder = { ...this.formDataSalesOrder, ...data }
    },
    handlerConnectPO () {
      this.$refs['dialog-connect-po'].show({ rfqid: this.data.rfqid })
    },
    handlerConnectWO () {
      this.$refs['dialog-connect-wo'].show({ rfqid: this.data.rfqid })
    },
    // REQUESTS
    _requestLoadSalesOrders (salesOrderID) {
      return ServiceSalesOrders
        .getDynamic(salesOrderID)
        .then(({ data }) => {
          this.dataSalesOrder = Object.assign({}, data)
        })
        .then(() => {
          const { poStillOpen } = this.dataSalesOrder
          if (poStillOpen !== this.poStillOpen) {
            const { query } = this.$route
            const name = poStillOpen
              ? 'SupplierPoWoOpen'
              : 'SupplierPoWoClose'
            this.$router.push({ name, query })
          }
        })
    },
    save () {
      this.isClosePoValidate = false

      this.$nextTick(() => {
        this.$bus
          .$emitPromise('validate-all-sections')
          .then(() => {
            this.isLoading = true
            return Promise.all([
              this.requestSaveRFQ(),
              this.requestSaveSalesOrder()
            ])
              .then(() => {
                this.requestSuccessHandler()
              })
              .catch((err) => {
                this.requestErrorHandler(err)
              })
              .then(() => {
                this.isLoading = false
              })
          })
          .catch((err) => {
            this.validateErrorHandler(err)
          })
      })
    },
    requestSaveRFQ () {
      const { id } = this.data
      return ServiceRFQs
        .patch({ id, ...this.formData })
    },
    requestSaveSalesOrder () {
      return ServiceSalesOrders
        .patch({ ...this.formDataSalesOrder, id: this.dataSalesOrder.id })
    }
  }
}
</script>
<style scoped>
  .root {
    position: relative;
    display: grid;
    height: 100%;
  }
  .inner {
    position: absolute;
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: 100%;
  }
  .content {
    display: grid;
    grid-template-columns: 2fr auto 1fr;
    height: 100%;
  }
  .content__scroll {
    overflow: hidden;
    padding-right: 1rem;
  }

  .content__border {
    padding-right: 1rem;
  }
</style>
